import { BLUE_500, getTestId, LILAC_600 } from '@airtel/air-design-system';
var planInfo = [{
  heading: '100 GB',
  subHeading: 'per-day'
}, {
  heading: '28 days',
  subHeading: 'validity'
}];
var priceDetails = {
  price: '₹558',
  gstDetails: 'limit',
  oldPrice: '₹000',
  offerText: 'saved ₹100'
};
var additionalBenefits = [{
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'Free Hellotunes'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'Wync Music'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}];
var buttonWidgetData = {
  direction: 'row',
  leftCta: {
    buttonType: 'tertiary',
    title: 'view details',
    version: 'fixed-padding'
  },
  rightCta: {
    buttonType: 'secondary',
    title: 'buy',
    version: 'fixed-padding',
    style: {
      alignSelf: 'flex-end'
    }
  }
};
var arr = Array.from({
  length: 10
}, () => ({
  additionalBenefits,
  planInfo,
  offerBannerText: ['· 2 GB coupon for free', '· 2 GB coupon for free'],
  hideRightChevronIcon: false,
  cardBorderColor: LILAC_600,
  buttonWidgetData,
  priceDetails,
  onPlanCardVisibleMetaData: {},
  infoTagArray: [{
    text: 'Extra 10 GB for USA',
    subType: 'offer'
  }, {
    text: 'Includes inflight benefits',
    subType: 'new'
  }]
}));
export var defaultProps = Object.assign({
  planListData: [{
    additionalBenefits,
    planInfo,
    offerBannerText: ['· 2 GB coupon for free', '· 2 GB coupon for free'],
    hideRightChevronIcon: false,
    cardBorderColor: LILAC_600,
    buttonWidgetData,
    priceDetails,
    onPlanCardVisibleMetaData: {},
    showEmptyInfoTagContainer: true,
    showEmptyInfoTagContainerMobile: false
  }, ...arr],
  showExpandCta: true,
  expandCtaData: {
    collapseCtaTitle: 'Show Less',
    expandedIconName: 'RightChevronButtonIcon',
    collapseIconName: 'UpChevronButtonIcon',
    onViewMoreCtaPress: {
      id: ''
    }
  },
  titleSectionProps: {
    title: 'Other postpaid plans',
    hideTopPadding: true,
    hideBottomPadding: true,
    subTitle: '9 more plans to choose from'
  },
  showTitleSection: true,
  packSelectionCardBorderColor: BLUE_500
}, getTestId('PlanListWidgetContainer'));